import { ValidatorFn, AbstractControl } from '@angular/forms';

export function phoneValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control.value) {
      return null;
    }
    const urlPattern = /^1*[1-9][0-9]{9}$/g;
    const isAccepted = urlPattern.test(control.value);
    return isAccepted ? null : { phone: true };
  };
}
